import React from "react";
import { BlockStack, Layout } from "@shopify/polaris";

import { STAT_METRICS, URGENT_TASKS_COUNT } from "app/dashboard/modules/operator/dashboardConfig";

import DashboardHeader from "./dashboardHeader/dashboardHeader";
import MarketplacePerformance from "./marketplacePerformance/marketplacePerformance";
import StatsRow from "./statsRow/statsRow";
import UrgentTasksBanner from "./urgentTasksBanner/urgentTasksBanner";

const DashboardView = () => (
  <Layout.Section>
    <BlockStack gap="500">
      <UrgentTasksBanner taskCount={URGENT_TASKS_COUNT} />
      <DashboardHeader />
      <StatsRow metrics={STAT_METRICS} />
      <MarketplacePerformance />
    </BlockStack>
    </Layout.Section>
);

export default DashboardView;
